/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceScrollNavItem } from './SurfaceScrollNavItem';
import {
    SurfaceScrollNavItemFromJSON,
    SurfaceScrollNavItemFromJSONTyped,
    SurfaceScrollNavItemToJSON,
    SurfaceScrollNavItemToJSONTyped,
} from './SurfaceScrollNavItem';

/**
 * 
 * @export
 * @interface SurfaceScrollNavConfig
 */
export interface SurfaceScrollNavConfig {
    /**
     * 
     * @type {Array<SurfaceScrollNavItem>}
     * @memberof SurfaceScrollNavConfig
     */
    items?: Array<SurfaceScrollNavItem>;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceScrollNavConfig
     */
    sticky?: boolean;
    /**
     * Pixel offset from top when sticky (syncs with header height). Default 60.
     * @type {number}
     * @memberof SurfaceScrollNavConfig
     */
    stickyTopOffset?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceScrollNavConfig
     */
    style?: SurfaceScrollNavConfigStyleEnum;
    /**
     * Horizontal alignment of nav items. Default "left".
     * @type {string}
     * @memberof SurfaceScrollNavConfig
     */
    alignment?: SurfaceScrollNavConfigAlignmentEnum;
}


/**
 * @export
 */
export const SurfaceScrollNavConfigStyleEnum = {
    cards: 'cards',
    tabs: 'tabs',
    pills: 'pills',
    minimal: 'minimal'
} as const;
export type SurfaceScrollNavConfigStyleEnum = typeof SurfaceScrollNavConfigStyleEnum[keyof typeof SurfaceScrollNavConfigStyleEnum];

/**
 * @export
 */
export const SurfaceScrollNavConfigAlignmentEnum = {
    left: 'left',
    center: 'center',
    right: 'right'
} as const;
export type SurfaceScrollNavConfigAlignmentEnum = typeof SurfaceScrollNavConfigAlignmentEnum[keyof typeof SurfaceScrollNavConfigAlignmentEnum];


/**
 * Check if a given object implements the SurfaceScrollNavConfig interface.
 */
export function instanceOfSurfaceScrollNavConfig(value: object): value is SurfaceScrollNavConfig {
    return true;
}

export function SurfaceScrollNavConfigFromJSON(json: any): SurfaceScrollNavConfig {
    return SurfaceScrollNavConfigFromJSONTyped(json, false);
}

export function SurfaceScrollNavConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceScrollNavConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(SurfaceScrollNavItemFromJSON)),
        'sticky': json['sticky'] == null ? undefined : json['sticky'],
        'stickyTopOffset': json['stickyTopOffset'] == null ? undefined : json['stickyTopOffset'],
        'style': json['style'] == null ? undefined : json['style'],
        'alignment': json['alignment'] == null ? undefined : json['alignment'],
    };
}

export function SurfaceScrollNavConfigToJSON(json: any): SurfaceScrollNavConfig {
    return SurfaceScrollNavConfigToJSONTyped(json, false);
}

export function SurfaceScrollNavConfigToJSONTyped(value?: SurfaceScrollNavConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(SurfaceScrollNavItemToJSON)),
        'sticky': value['sticky'],
        'stickyTopOffset': value['stickyTopOffset'],
        'style': value['style'],
        'alignment': value['alignment'],
    };
}

